module.exports = __webpack_public_path__ + "img/agua-sanitaria-mobile.292673d6.png";